import { useCallback, useRef } from "react";
import api from "../api";

const useRicercaSearch = () => {
  const abortControllerRef = useRef(null);

  const loadOptions = useCallback(async (inputValue) => {
    const query = inputValue?.trim();
    if (!query) {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
        abortControllerRef.current = null;
      }
      return [];
    }

    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const controller = new AbortController();
    abortControllerRef.current = controller;

    try {
      const response = await api.get("/ricerche", {
        params: {
          page: 0,
          size: 10,
          titoloCorso_like: query,
        },
        signal: controller.signal,
      });

      const ricerche = Array.isArray(response.data?.content)
        ? response.data.content
        : Array.isArray(response.data)
        ? response.data
        : [];

      return ricerche.map((ricerca) => ({
        value: ricerca.id,
        label: `${ricerca.titoloCorso ?? ""}`.trim(),
        ricerca,
      }));
    } catch (error) {
      if (!controller.signal.aborted) {
        console.error(error);
      }
      return [];
    }
  }, []);

  return loadOptions;
};

export default useRicercaSearch;

